import {DataStatus} from 'platform/components';
import {Grid} from 'platform/foundation';

import {OperationTypeCount} from '@dms/api/settings';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {aggregateOperationTypes} from '../utils/aggregateOperationTypes';
import {PayPerUseOperationCard} from './PayPerUseOperationCard';

interface PayPerUseOperationCardsProps extends RequiredTestIdProps {
  operationTypes: OperationTypeCount[];
  totalCount: number;
}

export function PayPerUseOperationCards(props: PayPerUseOperationCardsProps) {
  const groups = aggregateOperationTypes(props.operationTypes);

  return (
    <DataStatus
      isEmpty={groups.length === 0}
      emptyMessage={i18n.t('page.homepage.payPerUse.empty')}
      minHeight={40}
    >
      <Grid columns={[1, 2, 3, 4]} spacing={4}>
        {groups.map((group) => (
          <PayPerUseOperationCard
            key={group.groupId}
            operationType={group}
            totalCount={props.totalCount}
            data-testid={suffixTestId(`operation-${group.groupId}`, props)}
          />
        ))}
      </Grid>
    </DataStatus>
  );
}
